export const AgencySizes = [
  {
    name: '2-10',
    value: 'size_2_10',
  },
  {
    name: '11-50',
    value: 'size_11_50',
  },
  {
    name: '51-200',
    value: 'size_51_200',
  },
  {
    name: '201-500',
    value: 'size_201_500',
  },
  {
    name: '501-1000',
    value: 'size_501_1000',
  },
  {
    name: '1001-5000',
    value: 'size_1001_5000',
  },
  {
    name: '5001-10000',
    value: 'size_5001_10000',
  },
  {
    name: '10001+',
    value: 'size_10001',
  },
];
